



















import { Component, Inject, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base/BaseComponent';
import { Action, Getter } from 'vuex-class';
import Dashboard from '@/views/dashboard/Dashboard.component.vue';
import { StoreNamespace } from '@/globals/StoreNamespaceGlobal';
import { ACCESS_TOKEN } from '@/types/authorization.types';
import { GLOBAL_ERROR, RESET_STORE } from '@/types/store.types';
import { AxiosError } from 'axios';
import ErrorDialog from '@/components/errors/ErrorDialog.component.vue';
import FormLoading from '@/components/loading/FormLoading.vue';
import { GOV } from '@/types/authentication.types';
import { TOKEN } from '@/types/system.types';


@Component({
  components: {
    FormLoading,
    Dashboard,
    ErrorDialog,
  },
})
export default class App extends BaseComponent {

  @Inject() public $validator: any;

  @Action(RESET_STORE) public resetStore;

  @Getter(ACCESS_TOKEN, StoreNamespace.AUTHORIZATION) public accessToken!: string;
  @Getter(TOKEN, StoreNamespace.SYSTEM) public systemToken!: string;
  @Getter(GLOBAL_ERROR) public globalError!: AxiosError;
  @Getter(GOV, StoreNamespace.AUTHENTICATION) public gov!: string;

  private lang: string = '';
  private isError: boolean = false;
  private errorPreTitle: string = '';
  private errorStatusCode: string = '';
  private errorBodyTitle: string = '';
  private errorBodyContent: string = '';

  public created() {
    const me = this;
    me.$Progress.start();
    if (!this.isCompatibleBrowser()) {
      this.$router.push({ name: 'browser-compatibility' });
    }

    me.$router.beforeEach((to, from, next) => {
      if (to.matched.some(record => record.meta.windowRedirectAfter)) {
        window.location.href = to.fullPath;
        return;
      } else if (to.matched.some((record: any) => record.meta.authNotRequired)) {
        next();
        if (to.matched.some((record: any) => record.meta.resetStore)) {
          this.resetStore();
        }
      } else {
        next();
      }
    });

    me.$router.afterEach((to, from) => {
      me.$Progress.finish();
    });
  }

  public mounted() {
    this.lang = '' + this.$t('lang');
    document.getElementsByTagName('body')[0].setAttribute('dir', '' + this.$t('dir'));
    this.$Progress.finish();
  }

  @Watch('globalError')
  public onGlobalErrorChanged(error: AxiosError | null) {
    if (error) {
      let errorName = 'error';
      switch (error.response!.status) {
        case 401:
        case 403:
          errorName = 'session_timeout';
          break;
      }
      this.isError = true;
      this.errorPreTitle = 'errors.' + errorName + '.pre_title';
      this.errorStatusCode = '' + error.response!.status;
      this.errorBodyTitle = 'errors.' + errorName + '.body_title';
      this.errorBodyContent = 'errors.' + errorName + '.body_content';
    }
  }

  public logout() {
    this.resetStore();
    const loginRouting = this.gov ? 'login?c=gov' : 'login';
    this.$router.push({ path: loginRouting });
  }

  public systemInfoLogout() {
    this.resetStore();
    this.$router.push({ name: 'system-info-login' });
  }

  public closeDialog(): void {
    this.resetStore();
    this.$router.push({ name: 'login' });
    this.isError = false;
  }

  public confirmDialog(): void {
    this.isError = false;
  }

  public isCompatibleBrowser(): boolean {
    const ua: any = window.navigator.userAgent;
    const edge: any = ua.indexOf('Edge/');
    const isChrome: any = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    const isSafari: any = ua.indexOf('Safari') !== -1;
    const isFirefox: any = ua.indexOf('Firefox') !== -1;
    const isNativeAndroid: any = ((ua.indexOf('Mozilla/5.0') > -1 && ua.indexOf('Android ') > -1 &&
        ua.indexOf('AppleWebKit') > -1) && (ua.indexOf('Version') > -1));
    return edge > 0 || isChrome || isSafari || isFirefox || isNativeAndroid;
  }

  get hideHeaderAndMenu(): boolean {
    return !!this.$route.meta!.hideHeaderAndMenu;
  }

  get isLoggedIn(): boolean {
    return !!this.accessToken;
  }

}
